export default abstract class DiagramElement {
  parent: DiagramElement;
  children: DiagramElement[] = [];
  _subElements: DiagramElement[] = [];
  graphParent: DiagramElement;
  _x: number;
  _y: number;
  centerXOffset: number = 0;
  childGraphWidth: number = 0;
  childGraphHeight: number = 0;
  isTermination: boolean = false;
  isLinkConfigurable: boolean = true;

  abstract get const()
  abstract get stepWidth()
  abstract get stepHeight()

  get fullStepHeight() {
    return this.stepHeight + (this.const.StepBorderWidth * 2) +
      this.const.PlusLineLength +
      this.const.ArrowPointerLength +
      this.const.ArrowPointerOffset;
  }

  get fullStepWidth() {
    return this.stepWidth + 40;
  }

  // Has a sub graph
  get hasSubGraph() {
    return false;
  }

  abstract get client_id()

  get x() {
    if (this.graphParent) {
      return this._x + this.graphParent.x + this.graphParent.centerXOffset;
    } else {
      return this._x;
    }
  }
  set x(val) {
    this._x = val;
  }
  get y() {
    if (this.graphParent) {
      return this._y + this.graphParent.y + this.const.StepHeight;
    } else {
      return this._y;
    }
  }
  set y(val) {
    this._y = val;
  }

  get subElements() {
    return this._subElements;
  }
  set subElements(val) {
    this._subElements = val;

    let maxX = Number.MIN_SAFE_INTEGER, maxY = Number.MIN_SAFE_INTEGER, minX = Number.MAX_SAFE_INTEGER, minY = Number.MAX_SAFE_INTEGER;
    for (const subElement of this.subElements) {
      maxX = Math.max(maxX, subElement._x + subElement.stepWidth / 2);
      minX = Math.min(minX, subElement._x - subElement.stepWidth / 2);
      maxY = Math.max(maxY, subElement._y + subElement.stepHeight);
      minY = Math.min(minY, subElement._y);
    }
    // Get where the center of the child graph should be. If left is at -1100 and right is at 900, we would want to shift center x by 100.
    this.centerXOffset = (maxX + minX) / 2 * -1;
    this.childGraphWidth = maxX - minX;
    this.childGraphHeight = maxY - minY;
  }

  // relative coordinates from parent
  get coordinates() {
    const relativeX = this.x - (this.parent ? this.parent.x : 0);
    const relativeY = this.y - (this.parent ? this.parent.y + this.parent.fullStepHeight : 0);
    return [relativeX, relativeY];
  }

  get startX() {
    return this.x;
  }

  get startY() {
    return this.y;
  }

  get childCoordinates() {
    return this.children.map(x => x.coordinates);
  }

  get hasActions(): boolean {
    return false;
  }
}